<template>
    <ValidationObserver ref="form">
        <div class="row" @change="sendDataForLicenses">
            <div class="col-lg-12 mb-4">
                <div class="box">
                    <div class="box-offset">
                        <div class="box-ttl-wrap">
                            <div class="box-ttl">
                                Manual Applicant Upload
                            </div>
                            <div class="">
                                <a href="javascript:void(0)" class="btn btn--outline-primary btn--small" @click="collapseAll">Collapsible
                                    All</a>
                                <a href="javascript:void(0)" class="btn btn--outline-primary btn--small" @click="expandAll">Expand
                                    All</a>
                            </div>
                        </div>
                        <div id="accordion" class="accordion mt-3">
                            <AccordionCard title="Personal Details" collapseId="collapse1"
                                           :isCollapsed="isAllCollapsed">
                                <div class="row mt-3">
                                    <ValidationProvider
                                        name="First Name"
                                        rules="required|latin|min:2|max:100"
                                        class="col-md-6"
                                        v-slot="{ errors }"
                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">First name</label>
                                            <input type="text"
                                                   class="form-control"
                                                   v-model="personalData.name">
                                            <FormError
                                                :error="errors[0]"
                                                name="First Name"
                                            ></FormError>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        name="Middle Name"
                                        rules="latin|min:2|max:100"
                                        v-slot="{ errors }"
                                        class="col-md-6"
                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Middle Name</label>
                                            <input type="text"
                                                   class="form-control"
                                                   v-model="personalData.middle_name">
                                            <FormError :error="errors[0]" name="Middle Name"></FormError>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider name="Last Name"
                                                        rules="required|latin|min:2|max:100"
                                                        class="col-md-6"
                                                        v-slot="{ errors }">
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Last name</label>
                                            <input type="text"
                                                   class="form-control"
                                                   v-model="personalData.last_name">
                                            <FormError :error="errors[0]" name="Last Name"></FormError>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider name="Email"
                                                        rules="required|email"
                                                        v-slot="{ errors }"
                                                        class="col-lg-6">
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Email</label>
                                            <input type="email"
                                                   class="form-control"
                                                   v-model="personalData.email">
                                            <FormError :error="errors[0]" name="Email"></FormError>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        class="col-md-4" name="SSN"
                                        rules="required|customMin:11"
                                        v-slot="{ errors }"
                                    >
                                        <div class="form-group form-group-1">
                                            <div class="form-group form-group-1 mb-0">
                                                <label for="" class="form-label">Social Security Number</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-mask="'### ## ####'"
                                                    v-model="personalData.ssn"
                                                    @click="personalData.ssn = null"
                                                >
                                                <FormError :error="errors[0]" name="SSN"></FormError>
                                            </div>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider name="Date of birth"
                                                        rules="required"
                                                        v-slot="{errors}"
                                                        class="col-md-4">
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Date of Birth</label>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="form-group form-group-1 mb-0">
                                                        <input type="date"
                                                               @change="calculateAge"
                                                               class="form-control"
                                                               v-model="personalData.birth_date">
                                                        <div
                                                            v-show="personalData.age < 18 && personalData.age !== null"
                                                            style="color: red;font-size: 14px">
                                                            All applicants need to be at least 18
                                                            years old for eligibility
                                                        </div>
                                                        <FormError :error="errors[0]" name="Date of birth"></FormError>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider name="Phone number"
                                                        v-slot="{ errors }"
                                                        class="col-md-4"
                                                        rules="required|customMin:17">
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Phone</label>
                                            <input type="text"
                                                   class="form-control"
                                                   v-mask="'+1 (###) ###-####'"
                                                   v-model="personalData.cell_number">
                                            <FormError :error="errors[0]" name="Phone number"></FormError>
                                        </div>
                                    </ValidationProvider>
                                    <div class="col-md-6">
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Type address</label>
                                            <VueGoogleAutocomplete
                                                id="map1"
                                                :country="`us`"
                                                classname="form-control"
                                                placeholder="Start typing"
                                                v-on:placechanged="getAddressData"
                                            >
                                            </VueGoogleAutocomplete>
                                        </div>
                                    </div>
                                    <ValidationProvider
                                        name="Address"
                                        v-slot="{ errors }"
                                        rules="required"
                                        class="col-md-6"
                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Address</label>
                                            <input type="text" v-model="addressData.address" class="form-control">
                                            <FormError :error="errors[0]" name="Address"></FormError>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        name="City"
                                        v-slot="{ errors }"
                                        rules="required"
                                        class="col-md-4"
                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">City</label>
                                            <input type="text" v-model="addressData.city" class="form-control">
                                            <FormError :error="errors[0]" name="City"></FormError>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        class="col-md-4"
                                        name="State"
                                        v-slot="{ errors }"
                                        rules="required"
                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">State</label>
                                            <input type="text" v-model="addressData.state" class="form-control">
                                            <FormError :error="errors[0]" name="State"></FormError>
                                        </div>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        name="Zip"
                                        v-slot="{ errors }"
                                        rules="required"
                                        class="col-md-4"
                                    >
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Zip</label>
                                            <input type="text" v-model="addressData.zip" class="form-control">
                                            <FormError :error="errors[0]" name="Zip"></FormError>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </AccordionCard>

                            <AccordionCard title="Schedule Availability" collapseId="collapse2"
                                           :isCollapsed="isAllCollapsed">
                                <div class="table-holder table-responsive ">
                                    <table class="table shifts-table">
                                        <thead>
                                        <tr>
                                            <th>Shift/Days</th>
                                            <th>Mon</th>
                                            <th>Tue</th>
                                            <th>Wed</th>
                                            <th>Thu</th>
                                            <th>Fri</th>
                                            <th>Sat</th>
                                            <th>Sun</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>Morning</td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input
                                                            class="form-check-input-checkbox"
                                                            type="checkbox"
                                                            name="morning"
                                                            value="monday"
                                                            id="mon-mor"
                                                            v-model="availabilityData.morning">
                                                        <label class="form-check-label" for="mon-mor"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               name="morning"
                                                               value="tuesday"
                                                               id="tue-mor"
                                                               v-model="availabilityData.morning">
                                                        <label class="form-check-label" for="tue-mor"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               name="morning"
                                                               value="wednesday"
                                                               id="wed-mor"
                                                               v-model="availabilityData.morning">
                                                        <label class="form-check-label" for="wed-mor"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="thursday"
                                                               name="morning"
                                                               id="thu-mor"
                                                               v-model="availabilityData.morning">
                                                        <label class="form-check-label" for="thu-mor"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="friday"
                                                               name="morning"
                                                               id="fri-mor"
                                                               v-model="availabilityData.morning">
                                                        <label class="form-check-label" for="fri-mor"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="saturday"
                                                               name="morning"
                                                               id="sat-mor"
                                                               v-model="availabilityData.morning">
                                                        <label class="form-check-label" for="sat-mor"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="sunday"
                                                               name="morning"
                                                               id="sun-mor"
                                                               v-model="availabilityData.morning">
                                                        <label class="form-check-label" for="sun-mor"></label>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Afternoon</td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="monday"
                                                               name="afternoon"
                                                               id="aft-mon"
                                                               v-model="availabilityData.afternoon">
                                                        <label class="form-check-label" for="aft-mon"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="tuesday"
                                                               name="afternoon"
                                                               id="aft-tue"
                                                               v-model="availabilityData.afternoon">
                                                        <label class="form-check-label" for="aft-tue"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="wednesday"
                                                               name="afternoon"
                                                               id="aft-wed"
                                                               v-model="availabilityData.afternoon">
                                                        <label class="form-check-label" for="aft-wed"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="thursday"
                                                               name="afternoon"
                                                               id="aft-thu"
                                                               v-model="availabilityData.afternoon">
                                                        <label class="form-check-label" for="aft-thu"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="friday"
                                                               name="afternoon"
                                                               id="aft-fri"
                                                               v-model="availabilityData.afternoon">
                                                        <label class="form-check-label" for="aft-fri"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="saturday"
                                                               name="afternoon"
                                                               id="aft-sat"
                                                               v-model="availabilityData.afternoon">
                                                        <label class="form-check-label" for="aft-sat"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="sunday"
                                                               name="afternoon"
                                                               id="aft-sun"
                                                               v-model="availabilityData.afternoon">
                                                        <label class="form-check-label" for="aft-sun"></label>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Night</td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="monday"
                                                               name="night"
                                                               id="night-mon"
                                                               v-model="availabilityData.night">
                                                        <label class="form-check-label" for="night-mon"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="tuesday"
                                                               name="night"
                                                               id="night-tue"
                                                               v-model="availabilityData.night">
                                                        <label class="form-check-label" for="night-tue"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="wednesday"
                                                               name="night"
                                                               id="night-wed"
                                                               v-model="availabilityData.night">
                                                        <label class="form-check-label" for="night-wed"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="thursday"
                                                               name="night"
                                                               id="night-thu"
                                                               v-model="availabilityData.night">
                                                        <label class="form-check-label" for="night-thu"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="friday"
                                                               name="night"
                                                               id="night-fri"
                                                               v-model="availabilityData.night">
                                                        <label class="form-check-label" for="night-fri"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="saturday"
                                                               name="night"
                                                               id="night-sat"
                                                               v-model="availabilityData.night">
                                                        <label class="form-check-label" for="night-sat"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-1">
                                                    <div class="form-check">
                                                        <input class="form-check-input-checkbox" type="checkbox"
                                                               value="sunday"
                                                               name="night"
                                                               id="night-sun"
                                                               v-model="availabilityData.night">
                                                        <label class="form-check-label" for="night-sun"></label>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <p
                                        v-if="shouldShowMessage"
                                        style="font-size: 12px; color: red"
                                    >* select at least one field </p>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group form-group-1">
                                            <label for="" class="form-label">Please indicate if you have any times you
                                                are
                                                NOT able to work and why (other jobs, religious obligations,
                                                etc.)</label>
                                            <input type="text" class="form-control"
                                                   v-model="availabilityData.time_absence">
                                        </div>
                                    </div>
                                </div>
                            </AccordionCard>

                            <AccordionCard title="Emergency Contacts" collapseId="collapse3"
                                           :isCollapsed="isAllCollapsed">
                                <div class="mt-3">
                                    <div class="text-center">
                                        <p>Providing the information means that you give ORNA permission to contact all
                                            names listed below if necessary</p>
                                    </div>

                                    <EmergencyContact
                                        v-for="(contact) in emergencyContactsData.contacts"
                                        :contact.sync="contact"
                                        :key="contact.id"
                                        :lengthCnt="emergencyContactsData.contacts.length"
                                        @delete-contact="deleteContact"
                                    ></EmergencyContact>

                                    <div class="add-row text-right">
                                        <button class="add-link" @click.prevent="addContact">+ Add another</button>
                                    </div>
                                </div>
                            </AccordionCard>


                            <AccordionCard title="License Information" collapseId="collapse4"
                                           :isCollapsed="isAllCollapsed">
                                <ValidationProvider
                                    name="Position"
                                    rules="required"
                                    v-slot="{ errors }"
                                    class="col-md-6 "
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Position Applying</label>
                                        <select
                                            class="custom-select"
                                            v-model="licensesData.position_applying"
                                        >
                                            <option
                                                v-for="position in positions"
                                                :value="position.id"
                                            >
                                                {{ position.title }}
                                            </option>
                                        </select>
                                        <FormError :error="errors[0]" name="Position"></FormError>
                                    </div>
                                </ValidationProvider>
                                <ValidationProvider
                                    rules="required"
                                    name="Licenses"
                                    v-slot="{ errors }"
                                    class="col-md-12"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">I have the following security license</label>
                                        <div class="form-group form-group-1">
                                            <VueMultiSelect
                                                :options="licensesTypes"
                                                v-model="selectedLicenses"
                                                :selected_options="selectedLicenses"
                                            ></VueMultiSelect>

                                            <FormError :error="errors[0]" name="Licenses"></FormError>
                                        </div>
                                    </div>
                                </ValidationProvider>

                                <LicenseInput
                                    ref="license"
                                    v-for="license in filledLicenses"
                                    :key="license.type"
                                    :license.sync="license"
                                    v-show="isActiveLicense(license)"
                                ></LicenseInput>
                            </AccordionCard>

                        </div>
                        <div class="btns-wrap mt-4">
                            <a class="btn btn--outline-primary w-100 w-sm-auto">Cancel</a>
                            <a class="btn btn--secondary w-100 w-sm-auto" @click="validateForms">Save</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>

</template>

<script>
import EmergencyContact from "./EmergencyContact.vue";
import ApplicantsServices from "./services/ApplicantsServices";
import VueMultiSelect from "../../../../../resources/js/plugins/VueMultiSelect.vue";
import LicenseInput from "../../../AppUser/resources/js/CommonForms/LicenseInput.vue";
import AccordionCard from "../../../AppUser/resources/js/EmployeeAdmin/AccordionCard.vue";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import CommonService from "../../../AppUser/resources/js/services/CommonService";

export default {
    name: "AddNewApplicant",
    components: {
        AccordionCard,
        LicenseInput,
        VueMultiSelect,
        EmergencyContact,
        VueGoogleAutocomplete
    },
    data() {
        return {
            showErrorForAddress: false,
            userId: null,
            isAllCollapsed: true,
            filledLicenses: [],
            licensesList: [],
            licensesTypes: [],
            positions: [],
            states: [],
            selectedLicenses: [],
            personalData: {
                name: null,
                middle_name: null,
                last_name: null,
                email: null,
                cell_number: null,
                ssn: null,
                age: null,
                birth_date: null
            },
            addressData: {
                latitude: null,
                longitude: null,
                address: null,
                zip: null,
                city: null,
                term_living: null,
                period_living: null,
                state: null,
            },
            availabilityData: {
                night: [],
                morning: [],
                afternoon: [],
                time_absence: null,
            },
            emergencyContactsData: {
                contacts: [],
            },
            licensesData: {
                position_applying: null,
                licenses: []
            },
        }
    },
    methods: {
        addContact() {
            for (let i = 0; i < this.emergencyContactsData.contacts.length; i++) {
                this.emergencyContactsData.contacts[i].id = i + 1;
            }
            this.emergencyContactsData.contacts.push({
                id: null,
                name: null,
                term_know: null,
                phone: null,
            })
        },
        addLicenseDetails() {
            this.licensesList.forEach(({type, id, ...rest}) => {
                this.filledLicenses.push({
                    license_id: id,
                    type: type,
                    number: null,
                    expiration_date: null,
                    school_received: null,
                    experience: null,
                    show: {
                        ...rest
                    }
                });
            })
        },
        deleteContact(id) {
            this.emergencyContactsData.contacts = this.emergencyContactsData.contacts.filter((item) => item.id !== id)
        },
        deleteFlags() {
            this.licensesData.licenses = this.filledLicenses.map(({show, ...license}) => license);
        },
        calculateAge() {
            const bd = new Date(this.personalData.birth_date);
            const today = new Date();
            const diff = today.getTime() - bd.getTime()
            const age = (diff / 31536000000).toFixed()
            this.personalData.age = age
        },
        collapseAll() {
            this.isAllCollapsed = true;
        },
        async createNewApplicant() {
            try {
                const {data: id} = await ApplicantsServices.createApplicant(this.personalData)
                this.userId = id
                await this.sendAllData(id)
            } catch (e) {
                console.error(e)
            }
        },
        expandAll() {
            this.isAllCollapsed = false;
        },
        getAddressData(place) {
            let {
                administrative_area_level_1,
                locality,
                postal_code,
                route,
                street_number,
                longitude,
                latitude,
            } = place
            if (route && street_number) {
                this.addressData.address = `${street_number} ${route} `;
            } else {
                this.addressData.address = street_number || route || '';
            }
            this.addressData.longitude = longitude
            this.addressData.latitude = latitude
            this.addressData.zip = postal_code
            this.addressData.city = locality
            this.findStateFullName(administrative_area_level_1)
        },
        getLicensesType() {
            this.licensesTypes = this.licensesList.map(({type}) => type);
        },
        async getListOfLicenses() {
            try {
                const {data: licenses} = await CommonService.getListOfLicenses()
                this.licensesList = licenses
                this.getLicensesType();
                this.addLicenseDetails();
            } catch (error) {
                this.$handleErrors(error);
            }
        },
        async getListOfPositions() {
            try {
                const {data: positions} = await CommonService.getListOfPositions()
                this.positions = positions
            } catch (error) {
                this.$handleErrors(error);
            }
        },
        async getListOfStates() {
            try {
                const {data: states} = await CommonService.getListOfStates();
                this.states = states
            } catch (error) {
                this.$handleErrors(error);
            }
        },
        findStateFullName(stateN) {
            const foundState = this.states.find(state => state.abbreviation === stateN)
            this.addressData.state = foundState.name
        },
        isActiveLicense(license) {
            return this.selectedLicenses.includes(license.type)
        },
        sendDataForLicenses() {
            this.deleteFlags()
            this.licensesData.licenses = this.licensesData.licenses.filter(
                (license) => this.selectedLicenses.includes(license.type)
            );
        },
        async sendAllData(id) {
            this.$showLoadingMessage()
            const savingData = [
                await ApplicantsServices.saveAddressData(id, this.addressData),
                await ApplicantsServices.saveAvailabilityData(id, this.availabilityData),
                await ApplicantsServices.saveEmergencyData(id, this.emergencyContactsData),
                await ApplicantsServices.saveLicenseData(id, this.licensesData),
                await ApplicantsServices.setDateApplied(id)

            ]
            Promise.all(savingData)
                .then((responses) => {
                    if (responses) {
                        this.$showSuccessMessage('Applicant was created');
                        setTimeout(() => {
                            window.location.href = '/master-admin/applicants'
                        }, 1000)
                    }
                })
                .catch((error) => {
                    console.error('Something went wrong', error);
                    this.$showErrorMessage();
                });
        },
        setValidationErrors(form) {
            const validationErrors = [];

            for (const errorsKey in form.errors) {
                if (form.errors.hasOwnProperty(errorsKey)) {
                    if (form.errors[errorsKey].length) {
                        validationErrors.push(errorsKey);
                    }
                }
            }
            this.$showValidationErrorMessage(`These fields are empty or filled in incorrectly: ${validationErrors} `)
        },
        validateForms() {
            (async () => {
                const form = this.$refs.form
                const valid = await form.validate();

                if (!valid) {
                    this.setValidationErrors(form)
                    return;
                }
                try {
                    await this.createNewApplicant();

                } catch (error) {
                    this.$handleErrors(error)
                }
            })();
        },
    },
    computed: {
        shouldShowMessage() {
            return (
                this.availabilityData.morning.length === 0 &&
                this.availabilityData.afternoon.length === 0 &&
                this.availabilityData.night.length === 0
            );
        },
    },
    mounted() {
        this.addContact();
        this.getListOfPositions();
        this.getListOfLicenses();
        this.getListOfStates();
    },
}

</script>


<style scoped>

</style>
